import { IonContent, IonPage, IonCol, IonRow, IonGrid, IonButton, IonIcon, IonTextarea, IonFooter, useIonViewDidEnter, IonToast, useIonAlert, IonLabel } from '@ionic/react';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipEditPostPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { send } from 'ionicons/icons';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SelectGroupMembers, SelectPost, SelectPosts } from '../../store/FellowshipSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import IFellowshipPost from '../../interfaces/IFellowshipPost';
import { SelectCurrentUser, SelectNetworkConnected } from '../../store/UserSlice';
import PostTypes, { PostTypesValues } from '../../data/PostTypes';
import { GetMemberInfo } from '../../interfaces/IGroupMembers';
import NetworkNotification from '../../components/NetworkNotification/NetworkNotification';
import PostVideos from '../../components/PostVideos/PostVideos';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';

const FellowshipEditPostPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {

  const history = useHistory();
  const dbService = useContext(ServerDBContext);
  const memberDetails =  useSelector(SelectGroupMembers);
  const { postId } = useParams<{ navigation: string; postId: string; }>();
  const fellowshipPosts = useSelector(SelectPosts);
  const post = useSelector(SelectPost(postId));
  const [postInputText, setPostInputText] = useState('');
  const [toastMessageFailed, setToastMessageFailed] = useState('');
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const textArea = useRef<HTMLIonTextareaElement>(null);
  const editHeader = useRef<HTMLDivElement>(null);
  const editContentContainer = useRef<HTMLIonContentElement>(null);
  const networkConnected = useSelector(SelectNetworkConnected);

  useIonViewDidEnter(() => {
    setPostInputText(post?.postText ?? '');
  }, [post]);

  const styleSelector = (postType: PostTypesValues | undefined) => {
    switch(postType) {
      case PostTypes.bible :
        return 'bible-post-edit';
      case PostTypes.prayer :
        return 'prayer-post-edit';
      case PostTypes.fellowship :
        return 'fellowship-post-edit';
    }
  }

  const editPost = (post: IFellowshipPost) => {
    console.log('edit Post');
    if(postInputText && networkConnected) {

      // If old post thats is from the local DB consider pulling it down fresh before adding a edit...
      const updatedPost = {...post, postText: postInputText}
      if(fellowshipPosts.findIndex(indexedPost => indexedPost.id === post.id) > 5) {
        // If it is an old post, then pull it back to the top when it gets a new edit.
        // Note: This will only pull it to the top on a app refresh (because of FellowshipSlice.ts)
        // which keeps the posts from jumping around when a user is reading them.
        updatedPost.sortDate = new Date(Date.now());
      }
      dbService?.updatePost(updatedPost).then(result => {
        if(result.Success) {
          history.push(AppRouteInfo[AppRouteKeys.Fellowship].path
            , {direction: 'backward'})
        } else {
          setToastMessageFailed('Error: Failed to Post edit.');
          setDisplayToastFailed(true);
        }
      })
    } else if(!networkConnected) {
      setToastMessageFailed('NO INTERNET CONNECTION DETECTED - Connection is required to edit on a post.');
      setDisplayToastFailed(true);
    }
  }

  return (
    <IonPage className={`fellowship-edit-post ${styleSelector(post?.type)}`}>
      <PageHeader {...props} showBackButton={true} ></PageHeader>
      <IonContent ref={editContentContainer}>
        <IonGrid fixed={true} className="edit-page-grid">
          <IonRow >
            <IonCol className="edit-list-container">
              
              <h2 className="edit-post-title-text">{post?.title}</h2>
              <div ref={editHeader} className="edit-post-author">
                <div className="edit-box-author">{GetMemberInfo(post?.userId, memberDetails, 'displayName')}</div>
                <div className="edit-box-date">{new Date(post?.createdDate!).toLocaleString()}</div>
              </div>

              <p className="edit-post-body">
                <IonTextarea ref={textArea} value={postInputText} aria-label="Enter Your edit"
                  placeholder="Enter Your edit..."
                  autoCapitalize='sentences'
                  autoGrow={true} 
                  onIonInput={e => setPostInputText(e.detail.value?.toString()!)}>
                </IonTextarea>
              </p>
              </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonButton onClick={() => post && editPost(post)} className={`update-post-button ${styleSelector(post?.type)}`}>
                <IonIcon icon={send} slot='end'/>
                <IonLabel>UPDATE POST</IonLabel>
              </IonButton>
              </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <PostVideos 
                postText={post?.postText} 
                showEmbed={true} 
                cssClass={'edit-post-video-container'}></PostVideos>
            </IonCol>
          </IonRow>
        </IonGrid>

      </IonContent>
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastMessageFailed}
          duration={2500} />
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to edit on a post."></NetworkNotification>
    </IonPage>
  );
};

export default FellowshipEditPostPage;